/**
 * ブレークポイントの定義
 * 目安として、smallがスマホ、mediumがタブレット、large以上がdesktopとなる。
 * medium がyuffieの中では最も使われているサイズ。Bootstrapを参考にしています。
 *
 * @remarks
 *
 * 現状、yuffieには2種類のブレークポイントのセットが存在します。ここでは、pxベースのセットを元にしています。
 * - pxベース: プロダクトの機能で使用されている
 * - emベース: LP系の画面で使用されている
 * @see https://github.com/Findy/Yuffie/issues/9781#issuecomment-1619370744
 */
export const breakpoints = {
  xsmall: 0,
  small: 576,
  medium: 768,
  large: 1024,
  xlarge: 1200,
  mobile: 1088,
};

/**
 * 指定したブレークポイント以上の画面サイズにマッチするメディアクエリを返す
 * @param sizeName breakpoint name
 * @example
 * ```
 * const MyLayout = styled.div`
 *   display: none;
 *   ${breakpointHigher('medium')} {
 *     display: block;
 *   }
 * `
 * ```
 */
export const breakpointHigher = (
  sizeName: keyof typeof breakpoints
): string => {
  if (!(sizeName in breakpoints)) {
    throw new Error(`Invalid breakpoint name: ${sizeName}`);
  }

  return `@media (min-width: ${breakpoints[sizeName]}px)`;
};

/**
 * 指定したブレークポイント以下の画面サイズにマッチするメディアクエリを返す
 * @param sizeName breakpoint name
 * @example
 * ```
 * const MyLayout = styled.div`
 *   display: block;
 *   ${breakpointLower('small')} {
 *     display: none;
 *   }
 * `
 * ```
 */
export const breakpointLower = (sizeName: keyof typeof breakpoints): string => {
  if (!(sizeName in breakpoints)) {
    throw new Error(`Invalid breakpoint name: ${sizeName}`);
  }
  // 0.02px を引く理由
  // 高dpiのデバイスなど、特定の条件下でビューポートが小数の幅を持つことがある。
  // その場合に意図しない結果を防ぐために、精度の高い値を使用している。
  // https://getbootstrap.jp/docs/5.0/layout/breakpoints/#max-width
  return `@media (max-width: calc(${breakpoints[sizeName]}px - 0.02px))`;
};
